import { StringUnion } from '../../../../typescript';
import { BaseUrl } from '../../base-urls';

export const getWordPressHeaders = (): Record<string, string> => {
    return {
        'User-Agent': process.env.X_USER_AGENT ?? '',
        'x-wordpress-api-secret': process.env.WORDPRESS_API_FW_SECRET ?? '',
    };
};

const makeWordPressApiHeaders = (baseUrl?: StringUnion<BaseUrl>): Record<string, string> => {
    if (baseUrl !== 'wordpress') return {};
    return getWordPressHeaders();
};

export { makeWordPressApiHeaders };
